export enum EAccountManagementCustomersColumnKeys {
  ExternalID = 'external_id',
  Branch = 'branch_name',
  Accounts = 'accounts',
  Currencies = 'currencies',
}

export enum EAccountManagementCustomersInnerColumnKeys {
  RowNumber = 'row_number',
  AccountNumber = 'account_number',
  Currency = 'currency',
  AccountName = 'account_name',
  AccountStatus = 'account_status',
  StellarAddress = 'stellar_address',
  ActualBalance = 'actual_balance',
  Menu = 'menu',
  AccountGuid = 'guid',
}

export enum EQueryParams {
  Page = 'page',
  PageSize = 'page_size',
  CounterpartyGuid = 'counterparty_guid',
  Created = 'created',
}

export enum EAccountManagementCustomersAction {
  Edit = 'edit',
  Block = 'block',
  Delete = 'delete',
}

export enum EAccountManagementCustomerFormItemNames {
  Counterparty = 'counterparty',
  Customer = 'customer',
  Currency = 'currency',
  IBAN = 'iban',
}

export enum EModalType {
  Create = 'create',
  Edit = 'edit',
}

export enum EAccountManagementCustomersPageGetParams {
  Action = 'action',
}

export enum EAccountManagementCustomersPageGetParamsActionTypes {
  Create = 'create',
}
